export var PERIOD_SESSION = 'session';
export var PERIOD_DAYS = 'days';
export var PERIOD_ONCE = 'once';
export var PERIOD_LOGIN = 'login';
export var PERIOD_MINUTES = 'minutes';
export var INTERVAL_REGISTER_AND_EXPIRED = PERIOD_DAYS;
export var INTERVAL_AM_REGISTER_AND_EXPIRED = 3;
export var INTERVAL_REGISTER_AND_OPEN = PERIOD_DAYS;
export var INTERVAL_AM_REGISTER_AND_OPEN = 3;
export var INTERVAL_OVERDUE_AND_EXTENSION = PERIOD_LOGIN;
export var INTERVAL_AM_OVERDUE_AND_EXTENSION = 1;
export var OVERDUE_MIN = 0;
export var OVERDUE_MAX = 5;
export var INTERVAL_OVERDUE_VI = PERIOD_LOGIN;
export var INTERVAL_AM_OVERDUE_VI = 1;
export var OVERDUE_VI_FIRST = 0;
export var OVERDUE_VI_SECOND = 5;
export var OVERDUE_VI_THIRD = 10;
export var OVERDUE_VI_FOURTH = 19;
export var OVERDUE_VI_FIFTH = 27;
export var OVERDUE_VI_PRODUCT = '16';
export var INTERVAL_OVERDUE10 = PERIOD_SESSION;
export var INTERVAL_AM_OVERDUE10 = 1;
export var DAYS_OVERDUE10 = 10;
export var INTERVAL_OVERDUE28 = PERIOD_SESSION;
export var INTERVAL_AM_OVERDUE28 = 1;
export var DAYS_OVERDUE28 = 28;
export var INTERVAL_MISSING_DATA = PERIOD_DAYS;
export var INTERVAL_AM_MISSING_DATA = 7;
export var INTERVAL_INCORRECT_PHONE = PERIOD_DAYS;
export var INTERVAL_AM_INCORRECT_PHONE = 7;
export var INTERVAL_INACTIVE = PERIOD_DAYS;
export var INTERVAL_AM_INACTIVE = 1;
export var INTERVAL_NEWS_AND_LOAN_CLOSED = PERIOD_ONCE;
export var DUE_DATE_NEWS_AND_LOAN_CLOSED = 120;
export var INTERVAL_PRODUCT21 = PERIOD_DAYS;
export var INTERVAL_AM_PRODUCT21 = 7;
export var PRODUCT21_PRODUCT = '21';
export var PRODUCT21_OVERDUE = 1;
export var SCENARIO_SKIP = 'SKIP';
export var SCENARIO_USE = 'USE';
export var SCENARIO_STOP = 'STOP';
export var DEBT_COLLECTION = 'DEBT_COLLECTION';
export var CHATBOT_AUTOSTART_DONE = 'chatbotAutoStartDone';
export var CHATBOT_SCENARIOS = 'chatbotScenarios';
export var GRANTED_STATUS = 'GRANTED';
export var ACCEPT_NEWS_CONSENT = 'ACCEPT_NEWS';